export default __webpack_public_path__ + "static/media/port-logo-fhm.0a9ccae9.webp";